// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__XBN-l","content":"content__kLZqd","icon-box":"icon-box__n0DCs","icon":"icon__zwybd","name":"name__Soj2A","text":"text__-dXzb"};